import type { AtlasAdditionalPrompt } from '@secca/shared/components/atlas-chatbot/additional-prompts-dialog/atlas-chatbot-additional-prompts-dialog.component';

export const ADDITIONAL_SUGGESTED_PROMPTS_CONTEXT_OFF: AtlasAdditionalPrompt[] = [
  {
    category: 'General',
    title: 'Reserve',
    questions: {
      danish: 'Hvad er en reserve?',
      norwegian: 'Hva er en reserve?',
      swedish: 'Vad är en reserv?',
      finnish: 'Mikä reservi on?',
      english: 'What is a reserve?'
    }
  },
  {
    category: 'General',
    title: 'EHIC',
    questions: {
      danish: 'Hvad er EHIC?',
      norwegian: 'Hva er EHIC?',
      swedish: 'Vad är EHIC?',
      finnish: 'Mikä EHIC on?',
      english: 'What is EHIC?'
    }
  },
  {
    category: 'General',
    title: 'Online Care',
    questions: {
      danish: 'Hvad er Online Care?',
      norwegian: 'Hva er Online Care?',
      swedish: 'Vad är Online Care?',
      finnish: 'Mikä Online Care on?',
      english: 'What is Online Care?'
    }
  },
  {
    category: 'General',
    title: 'FindCare',
    questions: {
      danish: 'Hvad er FindCare?',
      norwegian: 'Hva er FindCare?',
      swedish: 'Vad är FindCare?',
      finnish: 'Mikä FindCare on?',
      english: 'What is FindCare?'
    }
  },
  {
    category: 'FinesseJabber',
    title: 'Cisco Jabber login',
    questions: {
      danish: 'Hvordan logger jeg ind i Cisco Jabber?',
      norwegian: 'Hvordan logger jeg inn i Cisco Jabber?',
      swedish: 'Hur loggar jag in i Cisco Jabber?',
      finnish: 'Miten kirjaudun Cisco Jabberiin?',
      english: 'How do I log in to Cisco Jabber?'
    }
  },
  {
    category: 'FinesseJabber',
    title: 'Jabber headset',
    questions: {
      danish: 'Hvad gør jeg, hvis mit headset ikke fungerer korrekt i Jabber?',
      norwegian: 'Hva gjør jeg hvis headsettet mitt ikke fungerer riktig i Jabber?',
      swedish: 'Vad gör jag om mitt headset inte fungerar korrekt i Jabber?',
      finnish: 'Mitä teen, jos kuulokemikrofonini ei toimi oikein Jabberissa?',
      english: 'What do I do if my headset is not working correctly in Jabber?'
    }
  },
  {
    category: 'FinesseJabber',
    title: 'Jabber startup',
    questions: {
      danish: 'Hvordan sikrer jeg, at Jabber starter automatisk?',
      norwegian: 'Hvordan sikrer jeg at Jabber starter automatisk?',
      swedish: 'Hur ser jag till att Jabber startar automatiskt?',
      finnish: 'Miten varmistan, että Jabber käynnistyy automaattisesti?',
      english: 'How do I make sure Jabber starts automatically?'
    }
  },
  {
    category: 'FinesseJabber',
    title: 'Audio troubleshooting',
    questions: {
      danish: 'Hvad skal jeg tjekke, hvis lyden ikke fungerer?',
      norwegian: 'Hva bør jeg sjekke hvis lyden ikke fungerer?',
      swedish: 'Vad ska jag kontrollera om ljudet inte fungerar?',
      finnish: 'Mitä minun pitäisi tarkistaa, jos ääni ei toimi?',
      english: 'What should I check if the sound is not working?'
    }
  },
  {
    category: 'FinesseJabber',
    title: 'Answer call shortcut',
    questions: {
      danish: 'Hvilken genvej bruger jeg til at besvare et opkald i Jabber?',
      norwegian: 'Hvilken snarvei bruker jeg for å besvare et anrop i Jabber?',
      swedish: 'Vilken genväg använder jag för att besvara ett samtal i Jabber?',
      finnish: 'Mitä pikanäppäintä käytän vastatakseni puheluun Jabberissa?',
      english: 'Which shortcut do I use to answer a call in Jabber?'
    }
  },
  {
    category: 'FinesseJabber',
    title: 'Reject call',
    questions: {
      danish: 'Hvordan afviser jeg et indgående opkald?',
      norwegian: 'Hvordan avviser jeg et innkommende anrop?',
      swedish: 'Hur avvisar jag ett inkommande samtal?',
      finnish: 'Miten hylkään saapuvan puhelun?',
      english: 'How do I reject an incoming call?'
    }
  },
  {
    category: 'FinesseJabber',
    title: 'End call shortcut',
    questions: {
      danish: 'Hvilken genvej afslutter et aktivt opkald?',
      norwegian: 'Hvilken snarvei avslutter et aktivt anrop?',
      swedish: 'Vilken genväg avslutar ett aktivt samtal?',
      finnish: 'Mikä pikanäppäin lopettaa aktiivisen puhelun?',
      english: 'Which shortcut ends an active call?'
    }
  },
  {
    category: 'FinesseJabber',
    title: 'Hold call shortcut',
    questions: {
      danish: 'Hvilken genvej bruger jeg til at holde eller genoptage et opkald?',
      norwegian: 'Hvilken snarvei bruker jeg for å sette et anrop på vent eller gjenoppta det?',
      swedish: 'Vilken genväg använder jag för att parkera eller återuppta ett samtal?',
      finnish: 'Mitä pikanäppäintä käytän puhelun asettamiseen pitoon tai jatkamiseen?',
      english: 'Which shortcut do I use to hold or resume a call?'
    }
  },
  {
    category: 'FinesseJabber',
    title: 'Finesse login',
    questions: {
      danish: 'Hvordan logger jeg korrekt ind i Finesse?',
      norwegian: 'Hvordan logger jeg riktig inn i Finesse?',
      swedish: 'Hur loggar jag in korrekt i Finesse?',
      finnish: 'Miten kirjaudun oikein Finesseen?',
      english: 'How do I log in to Finesse correctly?'
    }
  },
  {
    category: 'FinesseJabber',
    title: 'Finesse number',
    questions: {
      danish: 'Hvilket nummer skal jeg skrive i Finesse, når jeg logger ind?',
      norwegian: 'Hvilket nummer skal jeg skrive inn i Finesse når jeg logger inn?',
      swedish: 'Vilket nummer ska jag ange i Finesse när jag loggar in?',
      finnish: 'Mikä numero minun pitää syöttää Finesseen kirjautuessani?',
      english: 'Which number should I enter in Finesse when I log in?'
    }
  },
  {
    category: 'Admission',
    title: 'Medical Advice task',
    questions: {
      danish: 'Hvornår skal der oprettes en task til Medical Advice?',
      norwegian: 'Når skal det opprettes en oppgave til Medical Advice?',
      swedish: 'När ska en uppgift skapas till Medical Advice?',
      finnish: 'Milloin Medical Advicelle pitää luoda tehtävä?',
      english: 'When should a task be created for Medical Advice?'
    }
  },
  {
    category: 'Admission',
    title: 'Admission task title',
    questions: {
      danish: 'Hvilken titel skal bruges ved oprettelse af task på en indlæggelse?',
      norwegian: 'Hvilken tittel skal brukes når det opprettes en oppgave for en innleggelse?',
      swedish: 'Vilken titel ska användas när en uppgift skapas för en inläggning?',
      finnish: 'Mitä otsikkoa tulee käyttää, kun luodaan tehtävä sairaalahoitoa varten?',
      english: 'Which title should be used when creating a task for an admission?'
    }
  },
  {
    category: 'Admission',
    title: 'Hospital preference',
    questions: {
      danish: 'Skal jeg indhente patientens hospitalsønske?',
      norwegian: 'Skal jeg innhente pasientens sykehusønske?',
      swedish: 'Ska jag inhämta patientens sjukhusönskemål?',
      finnish: 'Pitääkö minun selvittää potilaan sairaalatoive?',
      english: 'Should I obtain the patient\'s hospital preference?'
    }
  },
  {
    category: 'Admission',
    title: 'Hospital call information',
    questions: {
      danish: 'Hvilke oplysninger skal indhentes, før der ringes til et hospital?',
      norwegian: 'Hvilke opplysninger skal innhentes før man ringer til et sykehus?',
      swedish: 'Vilka uppgifter ska inhämtas innan man ringer till ett sjukhus?',
      finnish: 'Mitä tietoja pitää hankkia ennen kuin soitetaan sairaalaan?',
      english: 'Which information should be obtained before calling a hospital?'
    }
  },
  {
    category: 'Admission',
    title: 'Home hospital',
    questions: {
      danish: 'Hvordan finder jeg det korrekte hjemhospital?',
      norwegian: 'Hvordan finner jeg riktig hjemsykehus?',
      swedish: 'Hur hittar jag rätt hemsjukhus?',
      finnish: 'Miten löydän oikean kotisairaalan?',
      english: 'How do I find the correct home hospital?'
    }
  },
  {
    category: 'Admission',
    title: 'ICU admission',
    questions: {
      danish: 'Hvordan håndteres en ICU-indlæggelse?',
      norwegian: 'Hvordan håndteres en ICU-innleggelse?',
      swedish: 'Hur hanteras en ICU-inläggning?',
      finnish: 'Miten ICU-sairaalahoito käsitellään?',
      english: 'How is an ICU admission handled?'
    }
  },
  {
    category: 'Admission',
    title: 'Psychiatric patients',
    questions: {
      danish: 'Hvordan håndteres psykiatriske patienter?',
      norwegian: 'Hvordan håndteres psykiatriske pasienter?',
      swedish: 'Hur hanteras psykiatriska patienter?',
      finnish: 'Miten psykiatrisia potilaita käsitellään?',
      english: 'How are psychiatric patients handled?'
    }
  }
];

export const ADDITIONAL_SUGGESTED_PROMPTS_CONTEXT_ON: AtlasAdditionalPrompt[] = [
  {
    category: 'Customer',
    title: 'Insurance check',
    questions: {
      danish: 'Hvordan laver jeg forsikringstjek for denne kunde?',
      norwegian: 'Hvordan gjør jeg en forsikringssjekk for denne kunden?',
      swedish: 'Hur gör jag en försäkringskontroll för den här kunden?',
      finnish: 'Miten teen vakuutustarkistuksen tälle asiakkaalle?',
      english: 'How do I perform an insurance check for this customer?'
    }
  },
  {
    category: 'Main Task Template',
    title: 'Main Task Team DK',
    questions: {
      danish: 'Giv mig Main Task skabelonen og punkter for Team DK',
      norwegian: 'Gi meg Main Task-malen og punkter for Team DK',
      swedish: 'Ge mig Main Task-mallen och punkter för Team DK',
      finnish: 'Anna minulle Team DK:n Main Task -malli ja kohdat',
      english: 'Give me the Main Task template and points for Team DK'
    }
  },
  {
    category: 'Main Task Template',
    title: 'Main Task Team SE',
    questions: {
      danish: 'Giv mig Main Task skabelonen og punkter for Team SE',
      norwegian: 'Gi meg Main Task-malen og punkter for Team SE',
      swedish: 'Ge mig Main Task-mallen och punkter för Team SE',
      finnish: 'Anna minulle Team SE:n Main Task -malli ja kohdat',
      english: 'Give me the Main Task template and points for Team SE'
    }
  },
  {
    category: 'Main Task Template',
    title: 'Main Task Team NO',
    questions: {
      danish: 'Giv mig Main Task skabelonen og punkter for Team NO',
      norwegian: 'Gi meg Main Task-malen og punkter for Team NO',
      swedish: 'Ge mig Main Task-mallen och punkter för Team NO',
      finnish: 'Anna minulle Team NO:n Main Task -malli ja kohdat',
      english: 'Give me the Main Task template and points for Team NO'
    }
  },
  {
    category: 'Main Task Template',
    title: 'Main Task Team FI',
    questions: {
      danish: 'Giv mig Main Task skabelonen og punkter for Team FI',
      norwegian: 'Gi meg Main Task-malen og punkter for Team FI',
      swedish: 'Ge mig Main Task-mallen och punkter för Team FI',
      finnish: 'Anna minulle Team FI:n Main Task -malli ja kohdat',
      english: 'Give me the Main Task template and points for Team FI'
    }
  },
  {
    category: 'Incident',
    title: 'Incident country sanctions',
    questions: {
      danish: 'Er landet hvor hændelsen er sket på sanktionslisten?',
      norwegian: 'Er landet der hendelsen skjedde på sanksjonslisten?',
      swedish: 'Finns landet där händelsen inträffade på sanktionslistan?',
      finnish: 'Onko maa, jossa tapahtuma sattui, pakotelistalla?',
      english: 'Is the country where the incident occurred on the sanctions list?'
    }
  }
];
